import type { FirebaseConfig } from '@helios/auth-firebase-web';

/**
 * Build Firebase config from environment variables.
 */
export function getFirebaseConfig(): FirebaseConfig {
  const config: FirebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  };

  // Validate required fields
  if (!config.apiKey || !config.authDomain || !config.projectId || !config.appId) {
    throw new Error('Missing required Firebase configuration. Check your .env.web-admin file.');
  }

  return config;
}
